import { Autocomplete } from "..";

interface ISearch {
  handleViewAllDoctorsClick: () => void;
  handleViewMedicalGroups: any;
}

const SearchForSection: React.FC<ISearch> = (data) => {
  return (
    <>
      <div
        className="hide-for-small-only"
        style={{
          padding: "20px 70px 32px 70px",
          borderBottom: "1px solid #F5F9FD ",
          textAlign: "start",
        }}
      >
        <>
          <h3 className="color-secondary text-uppercase">
            Search for your Doctor
          </h3>
          <img
            src={
              (process.env.REACT_APP_PUBLIC_ASSETS_URL ?? "/images") +
              "/vector.svg"
            }
            alt="Vector"
            style={{ marginRight: "8px" }}
          />
          <div className="grid-y" style={{ padding: "40px 0px 0px 0px " }}>
            <Autocomplete
              handleViewMedicalGroups={data.handleViewMedicalGroups}
            />
            <div style={{ padding: "20px 0px 24px 0px" }}>
              If you don't see your doctor, give us a call.{" "}
              <span className="color-primary text-underline">
                <a href="tel:18882938272">1-888-293-8272</a>
              </span>{" "}
              (TTY: 711).
            </div>
            <div
              className="color-primary text-underline"
              style={{ cursor: "pointer" }}
              onClick={data.handleViewAllDoctorsClick}
            >
              View all doctors in your area
            </div>
          </div>
        </>
      </div>
      <div
        className="show-for-small-only"
        style={{
          padding: "20px",
          borderBottom: "1px solid #F5F9FD ",
          textAlign: "start",
        }}
      >
        <>
          <h3
            className="color-secondary text-uppercase"
            style={{ fontSize: "30px" }}
          >
            Search for your Doctor
          </h3>
          <img
            src={
              (process.env.REACT_APP_PUBLIC_ASSETS_URL ?? "/images") +
              "/vector.svg"
            }
            alt="Vector"
            style={{ marginRight: "8px" }}
          />
          <div className="grid-y" style={{ padding: "20px 0px 0px 0px " }}>
            <Autocomplete
              handleViewMedicalGroups={data.handleViewMedicalGroups}
            />
            <div style={{ padding: "20px 0px 24px 0px" }}>
              If you don't see your doctor, give us a call.{" "}
              <span className="color-primary text-underline">
                <a href="tel:18882938272">1-888-293-8272</a>
              </span>{" "}
              (TTY: 711).
            </div>
            <div
              className="color-primary text-underline"
              style={{ cursor: "pointer" }}
              onClick={data.handleViewAllDoctorsClick}
            >
              View all doctors in your area
            </div>
          </div>
        </>
      </div>
    </>
  );
};

export default SearchForSection;
